import { ApiCall, ParameterDefinition } from '@lcms/api-definition';
import { endpoints } from '../../endpoints';
import { PluginConfiguration } from '../../../types/plugin-configuration';

export type EndpointResponse = { configuration: PluginConfiguration; };
export const getEndpoint = new ApiCall<EndpointResponse>().post('get', { route: endpoints.getConfiguration, params: {
    id: ParameterDefinition.String
} });

export default getEndpoint;